import React from "react";
import PropTypes from "prop-types";
import getBaseLen from "../../helpers/getBaseLen";

function PositionOption({ option, isHighlighted }) {
  const hightlightCl = isHighlighted
    ? "tw-bg-blueGray-400 tw-opacity-100"
    : "bg-1 tw-opacity-60";
  const cl = "tw-transition-colors tw-duration-100 tw-bg-opacity-30";

  function getContent() {
    if (option.isGene) {
      const size = option?.region?.size ? getBaseLen(option.region.size) : "";
      return (
        <div>
          <div className="tw-flex tw-items-center">
            <div className="tw-flex-grow tw-font-bold">{option?.label}</div>
            <div className="tw-opacity-80">
              <div className="tw-text-right">{size}</div>
              <div className="tw-text-right tw-font-semibold">
                {option?.region?.chromosome.name}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (option.error) {
      return (
        <div className="tw-items-center color-danger">
          <div>{option.error}</div>
        </div>
      );
    }

    if (option.warning) {
      return (
        <div className="tw-items-center color-highlight">
          <div>{option.warning}</div>
        </div>
      );
    }

    return (
      <div>
        <div className="tw-flex tw-items-center">
          <div className="tw-flex-grow tw-font-bold">
            {option?.label || option?.name}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tw-text-2xs tw-w-80 tw-cursor-pointer tw-border-b border-1">
      <div className={`${hightlightCl} ${cl} color-1 tw-p-2 tw-text-xs`}>
        {getContent(option)}
      </div>
    </div>
  );
}

PositionOption.propTypes = {
  isHighlighted: PropTypes.bool.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    isGene: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
    region: PropTypes.shape({
      size: PropTypes.number,
      chromosome: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default PositionOption;
